export default function NotFoundPage() {
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100dvh",
        width: "100dvw",
        top: 0,
        left: 0,
        position: "absolute",
        alignSelf: "center",
        background: "black",
      }}
    >
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}
